import { DatePicker as MuiDatePicker, type DatePickerProps as MuiDatePickerProps } from '@mui/x-date-pickers/DatePicker'
import { LocalizationProvider as MuiLocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns'
import type { DateValidationError as MuiDateValidationError } from '@mui/x-date-pickers/models'

export const DatePicker = MuiDatePicker
export type DatePickerProps<TDate extends boolean> = MuiDatePickerProps<TDate>

export type DateValidationError = MuiDateValidationError
export const LocalizationProvider = MuiLocalizationProvider
export const DateAdapter = AdapterDateFns
